'use client';

import React, { useEffect, useState } from 'react';


export default function RumbaHeroBanner() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="relative overflow-hidden" style={{ minHeight: '220px' }}>
      {/* Animated multi-layer background */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at 10% 60%, rgba(220, 38, 38, 0.25) 0%, transparent 55%),
            radial-gradient(ellipse at 90% 30%, rgba(234, 88, 12, 0.2) 0%, transparent 50%),
            radial-gradient(ellipse at 50% 100%, rgba(124, 58, 237, 0.15) 0%, transparent 60%),
            linear-gradient(180deg, #0D0D14 0%, #130a0a 60%, #0D0D14 100%)
          `,
        }}
      />

      {/* Animated noise grain overlay */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
          backgroundSize: '128px',
        }}
      />

      {/* Floating orbs */}
      {mounted && (
        <>
          <div
            className="absolute rounded-full pointer-events-none"
            style={{
              width: '300px',
              height: '300px',
              top: '-80px',
              left: '-60px',
              background: 'radial-gradient(circle, rgba(220,38,38,0.12) 0%, transparent 70%)',
              animation: 'float-slow 8s ease-in-out infinite',
            }}
          />
          <div
            className="absolute rounded-full pointer-events-none"
            style={{
              width: '200px',
              height: '200px',
              bottom: '-40px',
              right: '10%',
              background: 'radial-gradient(circle, rgba(234,88,12,0.1) 0%, transparent 70%)',
              animation: 'float-slow 10s ease-in-out 2s infinite reverse',
            }}
          />
        </>
      )}

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-6 py-14 gap-4">
        {/* Live badge */}
        <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-red-500/40 bg-red-500/10 mb-1">
          <span className="w-2 h-2 rounded-full bg-red-500 live-pulse" />
          <span className="text-xs font-bold text-red-400 tracking-widest uppercase">En Vivo · 24/7</span>
        </div>

        {/* Station name */}
        <h1
          className="font-black tracking-tight leading-none"
          style={{
            fontSize: 'clamp(2.8rem, 8vw, 5.5rem)',
            background: 'linear-gradient(135deg, #ffffff 0%, #fca5a5 40%, #fb923c 80%, #f97316 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: 'none',
            letterSpacing: '-0.03em',
          }}
        >
          RUMBA
          <span
            style={{
              background: 'linear-gradient(135deg, #fb923c 0%, #ef4444 50%, #dc2626 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            EXPLOSIONS
          </span>
        </h1>

        {/* Tagline */}
        <p className="text-base md:text-lg text-white/60 font-medium max-w-md" style={{ fontFamily: 'var(--font-sans)' }}>
          La estación que hace vibrar tu corazón · Medellín, Colombia
        </p>

        {/* Frequency pills */}
        <div className="flex items-center gap-3 mt-1 flex-wrap justify-center">
          {['Salsa', 'Cumbia', 'Vallenato', 'Merengue', 'Reggaeton']?.map((genre) => (
            <span
              key={genre}
              className="text-xs font-semibold px-3 py-1 rounded-full border"
              style={{
                borderColor: 'rgba(251,146,60,0.3)',
                background: 'rgba(251,146,60,0.08)',
                color: 'rgba(251,146,60,0.9)',
              }}
            >
              {genre}
            </span>
          ))}
        </div>
      </div>

      {/* Bottom fade */}
      <div
        className="absolute bottom-0 left-0 right-0 h-12 pointer-events-none"
        style={{ background: 'linear-gradient(to bottom, transparent, var(--background))' }}
      />
    </div>
  );
}
